// loadComponent comunica con la libreria npm che abbiamo installato, qui stiamo importando McElement che in sostanza estende HTMLElement (lo trovi nella sezione test)
// tutti i componenti che ti servono vanno chiamati così, con /components/nome-componente.js se sono su npm, li trovi tutti nella tab Componenti in sezione test
await loadComponent('./components/mc-element.js', false);

// queste sono le uniche librerie che hanno "res" invece che "components", le ho messe qua solo per farti vedere come si importano
await loadComponent('./res/mc-utils.js', false); // la trovi documentata sulla tab McUtils nella sezione test
await loadComponent('./res/mc-events.js', false); // la trovi documentata sulla tab Eventi nella sezione test
await loadComponent('./res/mc-shopify.js', false); // la trovi documentata sulla tab McShopify nella sezione test

class HeaderMain extends McElement {
  
  static scrollClass = 'scroll';

  connectedCallback() {
    this.initScrollListener();
    this.addBtnEvent();
    this.bindSearchSubmit();
  }

  initScrollListener() {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 100 && !document.body.classList.contains(HeaderMain.scrollClass)) {
        document.body.classList.add(HeaderMain.scrollClass);
      } else {
        if (window.scrollY == 0 && document.body.classList.contains(HeaderMain.scrollClass)) {
          document.body.classList.remove(HeaderMain.scrollClass);
        }
      }
    });
  }

  addBtnEvent() {
    document.addEventListener('click', e => {
    const btn = e.target.closest('[data-menu-toggle]');
    if (!btn) return;
    document.body.classList.toggle('mobile-menu-open');
    });
  }

  bindSearchSubmit() {
    const inputs = this.querySelectorAll('[data-search-input]');
    inputs.forEach(input => {
      input.addEventListener('keydown', event => {
        if (event.key !== 'Enter') return;
        const searchUrl = input.dataset.searchUrl;
        if (!searchUrl) return;
        event.preventDefault();
        const url = new URL(searchUrl, window.location.origin);
        const query = input.value.trim();
        if (query) {
          url.searchParams.set('q', query);
        }
        window.location.href = url.toString();
      });
    });
  }
}

if (!customElements.get('header-main')) {
  customElements.define('header-main', HeaderMain);
}

window.HeaderMain = HeaderMain;
